<div #subBody class="sub-body" [ngStyle]="{'transform':transform, 'margin-left':offset+'px'}">
    <router-outlet></router-outlet>
    <app-user-idle *ngIf="userIdle"></app-user-idle>
</div>